export const FLAG_GETTING_PRICING_PROFILE_DATE_RANGES =
  'FLAG_GETTING_PRICING_PROFILE_DATE_RANGES';
export const GET_PRICING_PROFILE_DATE_RANGES =
  'GET_PRICING_PROFILE_DATE_RANGES';
export const CLEAR_PRICING_PROFILE_DATE_RANGES =
  'CLEAR_PRICING_PROFILE_DATE_RANGES';
export const GET_PRICING_PROFILE_DATE_RANGE = 'GET_PRICING_PROFILE_DATE_RANGE';
export const CLEAR_PRICING_PROFILE_DATE_RANGE =
  'CLEAR_PRICING_PROFILE_DATE_RANGE';
export const FLAG_PRICING_PROFILE_DATE_RANGE_ACTIVITY =
  'FLAG_PRICING_PROFILE_DATE_RANGE_ACTIVITY';
export const GET_PRICING_PROFILE_DATE_RANGE_FILTER =
  'GET_PRICING_PROFILE_DATE_RANGE_FILTER';
export const CLEAR_PRICING_PROFILE_DATE_RANGE_FILTER =
  'CLEAR_PRICING_PROFILE_DATE_RANGE_FILTER';
